module.exports = __webpack_public_path__ + "static/img/banner_1.5275220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_1.jpg
// module id = dEG5
// module chunks = 21